<div class="label-container">
    <div>
        <label class="clickable-label" (click)=moveToExplore()>{{ exploreLabel }} </label>
        <img src="../assets/images/filled.svg" />
    </div>

    <label (click)="onClick()" class="non-clickable-label" style="text-decoration: none;">{{ rostersLabel
        }}</label>
</div>